import { IGetAllRateioGeralUseCase } from "../../../presentation/useCases/read/get_all_rateio_geral_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";
import { RateioGeralLista } from "../../models/rateio_geral_listas";

/**
 * GetAllRateioGeralUseCase
 */

export class GetAllRateioGeralUseCase extends BasePaginatedUseCase<RateioGeralLista> implements IGetAllRateioGeralUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllRateioGeralLista(
    idContasPagar: number,
    currentPage?: number,
    rowsPerPage?: number): Promise<void> {
    const result = await this.repository.getAllRateioGeralLista(
      idContasPagar,
      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;

  }

}
